import { Button as AIMEButton } from "tot-loft-component-library";
import ReCAPTCHA from "react-google-recaptcha";
import { InfoCircleIcon } from "./assets";
import * as PRTNR from "./prtnr";
import Spinner from "./Spinner";
import { useAddressNow } from "./useAddressNow";
import {
  Section,
  Wrapper,
  SignupSignin,
  ContentBlock1,
  Content,
  EarningCashForMakingReferralsIsEasierThanEver,
  DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed,
  Frame58,
  Frame1409,
  GFeildsInfo,
  TooltipWrapper,
  TooltipText,
  ErrorMessage,
  LabelWrapper,
  Required,
  ReCAPTCHAWrapper,
} from "./components/Signup/styles";

export default function SignupSetupPayment({
  formData,
  setFormData,
  hasSubmitted,
  setHasSubmitted,
  generalError,
  setGeneralError,
  handleSubmit,
  handleSkip,
  isSubmitting,
  streetAddressRef,
  postalCodeRef,
  fieldErrors,
  setFieldErrors,
  handleInputChange,
  recaptchaRef,
  recaptchaToken,
  setRecaptchaToken,
}) {
  const API_KEY = process.env.REACT_APP_ADDRESSNOW_KEY;

  useAddressNow(API_KEY, (addressnow) => {
    addressnow.setConfig({
      fields: {
        line1: "#paymentStreet",
        postcode: "#paymentPostcode",
      },
      trigger: "#paymentStreet",
    });
  });

  return (
    <Section>
      <Wrapper>
        <SignupSignin>
          <ContentBlock1>
            <Content>
              <EarningCashForMakingReferralsIsEasierThanEver>
                Set Up Your Payment Details for Faster Payouts (Optional)
              </EarningCashForMakingReferralsIsEasierThanEver>
              <DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed>
                Setting up your Stripe account now will enable faster and more
                seamless reward payouts in the future. Please note that Paartner
                does not store any of your payment information.
              </DiscoverPaartnerSTrustedAlliesReadyToHelpYourFriendsWithTheServicesAndMarTechTheyNeedToSucceed>
            </Content>
          </ContentBlock1>

          <Frame58>
            <Frame1409>
              <PRTNR.Input
                name="accountHolderName"
                label="Account Holder Name"
                value={formData.accountHolderName}
                onChange={(e) =>
                  handleInputChange("accountHolderName", e.target.value)
                }
                required
                error={!!fieldErrors.accountHolderName}
                errorMessage={fieldErrors.accountHolderName}
              />
            </Frame1409>

            <PRTNR.Input
              name="accountNumber"
              label="Account Number"
              value={formData.accountNumber}
              onChange={(e) => {
                handleInputChange("accountNumber", e.target.value);
              }}
              required
              error={!!fieldErrors.accountNumber}
              errorMessage={fieldErrors.accountNumber}
            />
            <PRTNR.Input
              name="confirmAccountNumber"
              label="Confirm Account Number"
              value={formData.confirmAccountNumber}
              onChange={(e) => {
                handleInputChange("confirmAccountNumber", e.target.value);
              }}
              required
              error={!!fieldErrors.confirmAccountNumber}
              errorMessage={fieldErrors.confirmAccountNumber}
            />

            <Frame1409>
              <PRTNR.Input
                name="ifscSwiftCode"
                label="Sort Code"
                value={formData.ifscSwiftCode}
                onChange={(e) => {
                  handleInputChange("ifscSwiftCode", e.target.value);
                }}
                required
                error={!!fieldErrors.ifscSwiftCode}
                errorMessage={fieldErrors.ifscSwiftCode}
              />

              <PRTNR.Input
                name="dateOfBirth"
                label={
                  <LabelWrapper>
                    <span>Date of Birth</span> <Required>*</Required>
                    <TooltipWrapper>
                      <GFeildsInfo src={InfoCircleIcon} alt="icon" />
                      <TooltipText className="tooltip">
                        You must be a UK resident and at least 18 years of age
                        or older to become a Member on the Paartner Referral
                        Platform. You must provide your legal full name, a valid
                        e-mail address, and any other information requested in
                        order to complete the sign-up process to become a Member
                        (a "Paartner Account"). By signing up, you confirm that
                        you are legally capable of entering into binding
                        agreements and accept full responsibility for your use
                        of the Platform, including any tax or legal obligations
                        that may arise.
                      </TooltipText>
                    </TooltipWrapper>
                  </LabelWrapper>
                }
                type="text"
                placeholder="DD/MM/YYYY"
                value={formData.dateOfBirth}
                onChange={(e) => {
                  let value = e.target.value.replace(/\D/g, "");

                  if (value.length >= 1) {
                    const day = parseInt(value.slice(0, 2));
                    if (day > 31) value = value.slice(0, 1);
                  }

                  if (value.length >= 3) {
                    const month = parseInt(value.slice(2, 4));
                    if (month > 12) value = value.slice(0, 3);
                  }

                  if (value.length > 8) {
                    value = value.slice(0, 8);
                  }

                  let formatted = value;
                  if (value.length >= 2) {
                    formatted = value.slice(0, 2) + "/" + value.slice(2);
                  }
                  if (value.length >= 4) {
                    formatted =
                      value.slice(0, 2) +
                      "/" +
                      value.slice(2, 4) +
                      "/" +
                      value.slice(4);
                  }

                  handleInputChange("dateOfBirth", formatted);
                }}
                error={!!fieldErrors.dateOfBirth}
                errorMessage={fieldErrors.dateOfBirth}
                maxLength="10"
              />
            </Frame1409>

            <Frame1409>
              <PRTNR.Input
                ref={streetAddressRef}
                id="paymentStreet"
                name="paymentStreet"
                label="Street address"
                onChange={(e) => {
                  handleInputChange("streetAddress", e.target.value);
                }}
                required
                error={!!fieldErrors.streetAddress}
                errorMessage={fieldErrors.streetAddress}
              />
              <PRTNR.Input
                ref={postalCodeRef}
                id="paymentPostcode"
                name="paymentPostcode"
                label="Postal code"
                onChange={(e) => {
                  handleInputChange("postalCode", e.target.value);
                }}
                required
                error={!!fieldErrors.postalCode}
                errorMessage={fieldErrors.postalCode}
              />
            </Frame1409>
            <PRTNR.Input
              name="nationalInsuranceNumber"
              label={
                <LabelWrapper>
                  <span>National Insurance Number</span>
                  <TooltipWrapper>
                    <GFeildsInfo src={InfoCircleIcon} alt="icon" />
                    <TooltipText className="tooltip">
                      We ask for your National Insurance number because Paartner
                      is legally required to store it and report to HMRC once
                      your rewards exceed a certain threshold. You can opt to
                      provide this at a later stage, once you've reached that
                      threshold.
                    </TooltipText>
                  </TooltipWrapper>
                </LabelWrapper>
              }
              value={formData.nationalInsuranceNumber}
              onChange={(e) => {
                handleInputChange("nationalInsuranceNumber", e.target.value);
              }}
              error={!!formData.nationalInsuranceNumber}
              errorMessage={fieldErrors.nationalInsuranceNumber}
            />

            <ReCAPTCHAWrapper>
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={(token) => setRecaptchaToken(token)}
                onExpired={() => setRecaptchaToken(null)}
              />
            </ReCAPTCHAWrapper>

            {generalError && <ErrorMessage>{generalError}</ErrorMessage>}
            <AIMEButton
              size="small"
              onClick={() => {
                handleSubmit();
              }}
              disabled={isSubmitting}
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "row",
                alignItems: "center",
                flex: "none",
                gap: "10px",
                borderRadius: "48px",
                width: "320px",
                background: isSubmitting
                  ? "rgba(56, 65, 80, 1)"
                  : "rgb(33, 37, 67)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundPosition: "center",
                boxSizing: "border-box",
                padding: "16px 32px",
                "&:hover": {
                  background: isSubmitting
                    ? "rgb(33, 37, 67))"
                    : "rgb(33, 37, 67)",
                  opacity: isSubmitting ? "1" : "0.9",
                },
                "&:disabled": {
                  background: isSubmitting
                    ? "rgba(132, 137, 146, 1)"
                    : "rgb(33, 37, 67)",
                  opacity: isSubmitting ? "1" : "0.9",
                },
                "@media (max-width: 768px)": {
                  width: "260px",
                },
                "@media (max-width: 480px)": {
                  width: "100%",
                },
              }}
            >
              <span
                style={{
                  color: "white",
                  textOverflow: "ellipsis",
                  fontSize: "16px",
                  fontFamily: "Montserrat, sans-serif",
                  fontWeight: "600",
                  lineHeight: "110%",
                  textAlign: "left",
                }}
              >
                {isSubmitting ? <Spinner /> : "Submit"}
              </span>
            </AIMEButton>
            <PRTNR.Button
              variant="gray-light"
              disabled={isSubmitting}
              onClick={() => {
                handleSkip();
              }}
            >
              {isSubmitting ? <Spinner /> : "Set up Account Later "}
            </PRTNR.Button>
          </Frame58>
        </SignupSignin>
      </Wrapper>
    </Section>
  );
}
